
import Swiper from './common/Swiper.vue';
import { reachGoal } from './utils/metrika.js';

const SWIPER_STYLES = `
  :host .swiper {
    margin-left: calc(var(--side-indent) * -1);
    width: calc(100% + var(--side-indent) * 2);
    -webkit-mask-image: linear-gradient(
        to right, 
        transparent 0px, 
        black 40px, 
        black calc(100% - var(--side-indent)), 
        transparent 100%
    );
    mask-image: linear-gradient(
        to right, 
        transparent 0px, 
        black 40px, 
        black calc(100% - var(--side-indent)), 
        transparent 100%
    );
  }
  :host .swiper-wrapper {
    overflow: visible !important;
    align-items: stretch;
  }
  @media screen and (max-width: 1024px) {
    :host .swiper {
      margin-left: unset;
      width: 100%;
      mask-image: unset;
      -webkit-mask-image: unset;
    }
    :host .swiper-wrapper {
      align-items: stretch;
    }
  }
`;

export default {
  name: 'MeatPageRecipes',
  components: { Swiper },
  props: {
    data: {
      type: Object,
      required: true
    },
    common: {
        type: Object,
        default: () => ({})
    }
  },
  data() {
    return {
      openedModalData: null
    }
  },
  computed: {
    swiperOptions() {
      const realCount = this.data.items.length;

      return {
        slidesPerView: 3,
        spaceBetween: 12,
        loop: true,
        centeredSlides: true,
        autoplay: {
          enabled: true,
          speed: 6000,
        },
        navigation: {
          enabled: true,
        },
        pagination: {
          clickable: true,
          renderBullet: (index, className) => {
            if (index >= this.data.items.length) return '';
            return `<span class="${className}"></span>`;
          }
        },
        on: {
          navigationNext: () => {
            this.reachGoal('click_recipes_carousel_next')
          },
          navigationPrev: () => {
            this.reachGoal('click_recipes_carousel_prev')
          },
          slideChange: (swiper) => {
            const realIndex = swiper.realIndex % realCount;
            const bullets = swiper.pagination.bullets;
            bullets.forEach((bullet, i) => {
              bullet.classList.toggle('hide', i > realIndex + 4 || i < realIndex - 4);
              bullet.classList.toggle('swiper-pagination-bullet-active', i === realIndex);
            });
          }
        },
        breakpoints: { 
          0: { 
            slidesPerView: 1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
          1025: { 
            slidesPerView: 3,
            slidesOffsetBefore: 60,
            slidesOffsetAfter: 60,
          } 
        },
        injectStyles: [SWIPER_STYLES],
      };
    }
  },
  methods: { 
    reachGoal,
    openModal(recipe) {
      this.openedModalData = recipe;
      document.documentElement.classList.toggle('overflow', !!recipe);
    }
  },
}
